<template>
  <div class="connet">
    <div class="tableBox orderMain">
      <div class="CM_heand">
        <div class="filter-row">
          <div class="statusInput">
            <span>支付类型：</span>
            <el-select v-model="payType" placeholder="请选择">
              <el-option v-for="item in payTypeOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>

          <div class="statusInput">
            <span>处方类型：</span>
            <el-select v-model="type" placeholder="请选择">
              <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>

          <div class="statusInput">
            <span>医疗类别：</span>
            <el-select v-model="medType" placeholder="请选择">
              <el-option v-for="item in medTypeOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>

          <div class="statusInput">
            <span>处方种类：</span>
            <el-select v-model="prescrKind" placeholder="请选择">
              <el-option v-for="item in prescrKindOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>

          <div class="statusInput">
            <span>处方状态：</span>
            <el-select v-model="status" placeholder="请选择">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="search-row">
          <div class="searchTime">
            <el-date-picker v-model="value1" type="datetimerange" range-separator="——" start-placeholder="开始日期"
              end-placeholder="结束日期" @change="chooseTime" :clearable="false">
            </el-date-picker>
          </div>

          <div class="searchInput">
            <el-input placeholder="搜索处方号/用户姓名" v-model="keyword" prefix-icon="el-icon-search"
              @keyup.enter.native="search"></el-input>
          </div>

          <el-button @click="search" type="success">查询</el-button>
        </div>
      </div>
      <div class="orderTable">
        <el-table :data="tableData" :style="{ width: flexWidth + 'px' }" style="min-height: 94%" class="CF_style"
          v-loading="loading" :cell-class-name="tableRowClassName">
          <el-table-column label="开方时间" prop="openTime" width="160px">
          </el-table-column>
          <el-table-column label="处方类型" width="90px">
            <template slot-scope="scope">
              <span v-if="scope.row.type == null" class="statusStyle1">
                待上传
              </span>
              <span v-if="scope.row.type == '1'" class="statusStyle4">
                外配处方
              </span>
              <span v-if="scope.row.type == '2'" class="statusStyle2">
                院内处方
              </span>
            </template>
          </el-table-column>
          <el-table-column label="处方种类" width="90px">
            <template slot-scope="scope">
              <span v-if="scope.row.prescrKind == 1" class="statusStyle4">
                西药处方
              </span>
              <span v-if="scope.row.prescrKind == 2" class="statusStyle2">
                中药处方
              </span>
            </template>
          </el-table-column>
          <el-table-column label="支付类型" width="90px">
            <template slot-scope="scope">
              <span v-if="scope.row.payType == 1" class="statusStyle2">
                现金处方
              </span>
              <span v-else class="statusStyle4">
                医保处方
              </span>
            </template>
          </el-table-column>
          <el-table-column label="医疗类别" prop="medType" width="90px">
            <template slot-scope="scope">
              <span v-if="scope.row.medType === null" class="statusStyle4">
                普通门诊
              </span>
              <span v-if="scope.row.medType === '11'" class="statusStyle4">
                普通门诊
              </span>
              <span v-if="scope.row.medType === '140104'" class="statusStyle2">
                门诊慢病
              </span>
              <span v-if="scope.row.medType === '140201'" class="statusStyle3">
                门诊特病
              </span>
              <span v-if="scope.row.medType === '910101'" class="statusStyle">
                住院期间
              </span>
            </template>
          </el-table-column>
          <el-table-column label="处方号" prop="hiRxno" width="220px">
            <template slot-scope="scope">
              <span v-if="scope.row.type == null">
              </span>
              <span v-if="scope.row.type == '1'">
                <span v-if="scope.row.payType == '1'">
                  {{ scope.row.prescrNo }}
                </span>
                <span v-else>
                  {{ scope.row.hiRxno }}
                </span>
              </span>
              <span v-if="scope.row.type == '2'">
                {{ scope.row.hisPrescrNo }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="诊断" prop="diagName" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column label="患者姓名" prop="patientName" width="90px">
          </el-table-column>
          <el-table-column label="处方状态" width="90px">
            <template slot-scope="scope">
              <span v-if="scope.row.status == '0'" class="statusStyle1">
                已过期
              </span>
              <span v-if="scope.row.status == '1'" class="statusStyle2">
                待审方
              </span>
              <span v-if="scope.row.status == '2'" class="statusStyle3">待使用</span>
              <span v-if="scope.row.status == '3'" class="statusStyle4">
                已使用
              </span>
              <span v-if="scope.row.status == '4'" class="statusStyle">已作废</span>
              <span v-if="scope.row.status == '5'" class="statusStyle4">使用中</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="230px">
            <template slot-scope="scope">
              <div>
                <el-button type="text" @click="open(scope.row)">详情</el-button>
                <el-button type="text" v-if="scope.row.status == '1'" @click="ExamineEvent(scope.row)">审核
                </el-button>
                <el-button type="text" v-if="scope.row.status == '1' || scope.row.status == '2'"
                  @click="CancelEvent(scope.row)">撤销
                </el-button>
                <el-button type="text" @click="downLoad(scope.row.pdfPath, scope.row.selfPlatType)" v-if="
                  (scope.row.status == '2' || scope.row.status == '3' || scope.row.status == '5') && scope.row.pdfPath
                ">下载
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage1" :page-size="8"
        layout="total, prev, pager, next" :total="PageCounts" class="paginationBox" align="center">
      </el-pagination>
    </div>
    <el-dialog title="处方详情" :visible.sync="dialogVisible" width="70%">
      <table style="width: 100%; line-height: 28px; margin-bottom: 10px">
        <tr>
          <td>
            <span>开方时间：</span><span>{{ detailsData.openTime }}</span>
          </td>
          <td>
            <span>处方号：</span><span>{{
              detailsData.type == 1 ? (detailsData.payType == 1 ? detailsData.prescrNo : detailsData.hiRxno) :
                detailsData.hisPrescrNo
            }}</span>
          </td>
        </tr>
        <tr>
          <td>
            <span>患者姓名：</span><span>{{ detailsData.patientName }}</span>
          </td>
          <td>
            <span>诊断：</span><span>{{ detailsData.diagName }}</span>
          </td>
        </tr>
        <tr>
          <td>
            <span>处方状态：</span><span v-if="detailsData.status == '0'" class="statusStyle1">
              已过期
            </span>
            <span v-if="detailsData.status == '1'" class="statusStyle2">
              待审方
            </span>
            <span v-if="detailsData.status == '2'" class="statusStyle3">待使用</span>
            <span v-if="detailsData.status == '3'" class="statusStyle4">
              已使用
            </span>
            <span v-if="detailsData.status == '4'" class="statusStyle">已作废</span>
            <span v-if="detailsData.status == '5'" class="statusStyle5">使用中</span>
          </td>
          <td>
            <span>开方医生：</span><span>{{ detailsData.doctorName }}</span>
          </td>
        </tr>
        <tr>
          <td>
            <span>开方医院：</span><span>{{ detailsData.hospitalName }}</span>
          </td>
          <td>
            <span>注意事项：</span><span>{{ detailsData.note }}</span>
          </td>
        </tr>
      </table>
      <h3>诊断详情</h3>
      <el-table :data="detailsData.prescriptionDiseList" style="width: 100%; margin-bottom: 24px">
        <el-table-column prop="diagName" label="诊断名称"></el-table-column>
        <el-table-column prop="sympName" label="证候" v-if="detailsData.prescrKind == 2"></el-table-column>
        <el-table-column label="诊断类别">
          <template slot-scope="scope">
            <span v-if="scope.row.diagType == '1'">西医诊断</span>
            <span v-else>中医主病诊断</span>
          </template>
        </el-table-column>
        <el-table-column label="主诊断标志">
          <template slot-scope="scope">
            <span v-if="scope.row.mainDiagFlag == '1'">是</span>
            <span v-else>否</span>
          </template>
        </el-table-column>
      </el-table>

      <h3 v-if="detailsData.prescrKind == 2">用法用量</h3>
      <el-table v-if="detailsData.prescrKind == 2" :data="[detailsData]" style="width: 100%; margin-bottom: 24px">
        <el-table-column prop="num" label="数量"></el-table-column>
        <el-table-column label="煎药方式">
          <template slot-scope="scope">
            <span v-if="scope.row.decoctingMethod == 1">自煎</span>
            <span v-else-if="scope.row.decoctingMethod == 2">代煎</span>
            <span v-else-if="scope.row.decoctingMethod == 3">膏方</span>
            <span v-else-if="scope.row.decoctingMethod == 4">磨粉</span>
            <span v-else>无</span>
          </template>
        </el-table-column>
        <el-table-column prop="wayName" label="用法"></el-table-column>
        <el-table-column prop="frquName" label="频次"></el-table-column>
        <el-table-column prop="frquNum" label="每日剂数"></el-table-column>
        <el-table-column prop="frquPreNum" label="每剂分几次使用"></el-table-column>
        <el-table-column label="单次用量">
          <template slot-scope="scope">
            {{ scope.row.sinDoscnt }}{{ scope.row.sinDosunt }}
          </template>
        </el-table-column>
        <el-table-column prop="usageTime" label="用药时间"></el-table-column>
      </el-table>

      <h3>药品列表</h3>
      <el-table :data="details">
        <el-table-column property="drugCode" label="药品编码"></el-table-column>
        <el-table-column property="drugName" label="药品名称"></el-table-column>
        <el-table-column property="specification" label="规格" :show-overflow-tooltip="true"
          v-if="detailsData.prescrKind != 2"></el-table-column>
        <el-table-column label="总量" width="84px" v-if="detailsData.prescrKind != 2">
          <template slot-scope="scope">
            <div>
              {{
                scope.row.minPackageQuantity
              }}{{ scope.row.minPreparationUnit }}/{{
                scope.row.minPackageUnit
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量">
          <template slot-scope="scope">
            <span v-if="detailsData.prescrKind == 2">{{ scope.row.drugNumber }} {{ scope.row.minPackageUnit }}</span>
            <span v-else>{{ scope.row.drugNumber }}</span>
          </template>
        </el-table-column>
        <el-table-column property="frquName" label="频次" width="125px"
          v-if="detailsData.prescrKind != 2"></el-table-column>
        <el-table-column property="wayName" label="用法" v-if="detailsData.prescrKind != 2"></el-table-column>
        <el-table-column prop="sinDoscnt" label="单次用量" v-if="detailsData.prescrKind != 2"></el-table-column>
        <el-table-column prop="sinDosunt" label="单次计量单位" v-if="detailsData.prescrKind != 2"></el-table-column>
        <el-table-column property="days" label="天数" v-if="detailsData.prescrKind != 2"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog" type="success" plain>取 消</el-button>
        <el-button type="success" @click="closeDialog">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="处方审核" :visible.sync="ExamineDialog" width="90%" top="3vh" custom-class="audit-dialog">
      <div style="display: flex; gap: 12px; height: 80vh; overflow: hidden;">
        <div
          style="flex: 1; border-right: 1px solid #ddd; padding-right: 20px; display: flex; flex-direction: column; position: relative;">

          <div class="zoom-bar">
            <span class="zoom-num">{{ Math.round(scale) }}%</span>
            <i class="el-icon-minus" @click="scale > 50 ? scale -= 10 : null"></i>
            <i class="el-icon-plus" @click="scale < 300 ? scale += 10 : null"></i>
          </div>
          <div v-loading="examineLoading"
            style="flex: 1; height: 100%; padding: 20px; box-sizing: border-box; background: #ebebeb; display: flex; justify-content: center; align-items: flex-start; overflow: auto;">
            <vue-pdf-embed v-if="examinePdfUrl && isPdf" :source="examinePdfUrl" :scale="5"
              :style="{ width: scale + '%' }" class="pdf-content" />
            <img v-else-if="examineImg && !isPdf" :src="examineImg" class="img-content"
              :style="{ width: scale + '%' }" />

            <el-empty v-else-if="!examineLoading" description="暂无处方预览"></el-empty>
          </div>
        </div>

        <div style="flex: 1; display: flex; flex-direction: column; overflow: hidden;">

          <div style="flex: 1; overflow-y: auto; padding-right: 12px;">
            <table style="width: 100%; line-height: 28px; margin-bottom: 10px">
              <tr>
                <td><span>开方时间：</span><span>{{ detailsData.openTime }}</span></td>
                <td><span>处方号：</span><span>{{ detailsData.hiRxno || detailsData.prescrNo }}</span></td>
              </tr>
              <tr>
                <td><span>患者姓名：</span><span>{{ detailsData.patientName }}</span></td>
                <td><span>年龄：</span><span>{{ detailsData.patientAge }}</span></td>
              </tr>
              <tr>
                <td>
                  <span>性别：</span>
                  <span v-if="detailsData.patientSex === 1">男</span>
                  <span v-else-if="detailsData.patientSex === 2">女</span>
                  <span v-else>-</span>
                </td>
                <td><span>诊断：</span><span>{{ detailsData.diagName }}</span></td>
              </tr>
              <tr>
                <td>
                  <span>处方状态：</span>
                  <span :class="getStatusClass(detailsData.status)">{{ getStatusLabel(detailsData.status) }}</span>
                </td>
                <td><span>开方医生：</span><span>{{ detailsData.doctorName }}</span></td>
              </tr>
              <tr>
                <td><span>开方医院：</span><span>{{ detailsData.hospitalName }}</span></td>
                <td><span>注意事项：</span><span>{{ detailsData.note }}</span></td>
              </tr>
            </table>
            <h3 class="audit-h3">诊断详情</h3>
            <el-table :data="detailsData.prescriptionDiseList" style="width: 100%; margin-bottom: 24px"
              class="no-border-table">
              <el-table-column prop="diagName" label="诊断名称"></el-table-column>
              <el-table-column v-if="detailsData.prescrKind === 2" prop="sympName" label="证候"></el-table-column>
              <el-table-column label="诊断类别">
                <template slot-scope="scope">
                  <span>{{ scope.row.diagType == '1' ? '西医诊断' : '中医主病诊断' }}</span>
                </template>
              </el-table-column>
              <el-table-column label="主诊断标志">
                <template slot-scope="scope">{{ scope.row.mainDiagFlag == '1' ? '是' : '否' }}</template>
              </el-table-column>
            </el-table>
            <div v-if="detailsData.prescrKind === 2">
              <h3 class="audit-h3">用法用量</h3>
              <el-table :data="[detailsData]" style="width: 100%; margin-bottom: 24px" class="no-border-table">
                <el-table-column prop="num" label="数量"></el-table-column>
                <el-table-column label="煎药方式">
                  <template slot-scope="scope">
                    <span v-if="scope.row.decoctingMethod == 1">自煎</span>
                    <span v-else-if="scope.row.decoctingMethod == 2">代煎</span>
                    <span v-else-if="scope.row.decoctingMethod == 3">膏方</span>
                    <span v-else-if="scope.row.decoctingMethod == 4">磨粉</span>
                    <span v-else>无</span>
                  </template>
                </el-table-column>
                <el-table-column prop="wayName" label="用法"></el-table-column>
                <el-table-column prop="frquName" label="频次"></el-table-column>
                <el-table-column prop="frquNum" label="每日剂数"></el-table-column>
              </el-table>
            </div>

            <h3 class="audit-h3">药品列表</h3>
            <el-table :data="details" style="width: 100%;" class="no-border-table">
              <el-table-column property="drugCode" label="药品编码"
                :width="detailsData.prescrKind === 2 ? '' : '220'"></el-table-column>
              <el-table-column property="drugName" label="药品名称"
                :width="detailsData.prescrKind === 2 ? '' : '150'"></el-table-column>

              <template v-if="detailsData.prescrKind !== 2">
                <el-table-column property="specification" label="规格" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="总量" width="84px">
                  <template slot-scope="scope">
                    {{ scope.row.minPackageQuantity }}{{ scope.row.minPreparationUnit }}/{{ scope.row.minPackageUnit }}
                  </template>
                </el-table-column>
              </template>

              <el-table-column label="数量">
                <template slot-scope="scope">
                  <span>{{ scope.row.drugNumber || scope.row.num }} {{ detailsData.prescrKind === 2 ?
                    (scope.row.minPackageUnit || 'g') : '' }}</span>
                </template>
              </el-table-column>

              <template v-if="detailsData.prescrKind !== 2">
                <el-table-column property="frquName" label="频次" width="125px"></el-table-column>
                <el-table-column property="wayName" label="用法"></el-table-column>
                <el-table-column property="days" label="天数"></el-table-column>
              </template>
            </el-table>
          </div>

          <div
            style="padding: 20px; background: #fafafa; border: 1px solid #EBEEF5; border-radius: 4px; box-shadow: 0 -2px 10px rgba(0,0,0,0.05); margin-top: 10px;">
            <div style="margin-bottom: 16px;">
              <span style="margin-right: 12px; font-weight: bold;">审核状态：</span>
              <el-radio-group v-model="auditStatus">
                <el-radio :label="1">同意</el-radio>
                <el-radio :label="2">驳回</el-radio>
              </el-radio-group>
            </div>
            <div v-if="auditStatus === 2">
              <span style="display: block; margin-bottom: 8px; color: #F56C6C; font-weight: bold;">驳回原因：</span>
              <el-input type="textarea" :rows="3" v-model="ExamineNote" placeholder="请输入驳回具体原因..."
                resize="none"></el-input>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="ExamineDialog = false" plain type="success">取 消</el-button>
        <el-button @click="handleExamineSubmit" type="success">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="处方撤销" :visible.sync="CancelDialog" width="30%">
      <span style="line-height: 40px"><span style="color: red">*</span>撤销原因：</span>
      <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入内容" v-model="Cancel_note"
        resize="none">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="CancelDialog = false" type="success" plain>取 消</el-button>
        <el-button @click="CancelPost" type="success">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="tipsFlag" width="30%" :show-close="false" :close-on-click-modal="false" class="tipsMsgBox"
      :modal="false">
      <span style="font-size: 20px; font-weight: 800">{{ tipsMsg }}</span>
    </el-dialog>
  </div>
</template>
<script>
import store from "../../../store/store";
import { Cancel, downLoadPdf, Examine, prescriptionList, } from "../../../api/index";
import pdf from 'vue-pdf'
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
import { closeNotify } from "../../../utils/socket";
export default {
  // eslint-disable-next-line vue/no-unused-components
  components: { pdf, VuePdfEmbed },
  name: "App",
  data() {
    const now = new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const day = now.getDate().toString().padStart(2, '0');
    const start = `${year}-${month}-${day} 00:00:00`;
    const end = `${year}-${month}-${day} 23:59:59`;
    return {
      tableData: [],
      value1: [start, end],
      dialogVisible: false,
      details: [{}],
      PageCounts: 1,
      currentPage1: 1,
      searchData: "",
      ExamineDialog: false,
      CancelDialog: false,
      ExamineNote: "",
      Cancel_note: "",
      detailsData: [],
      loading: true,
      id: "",
      postData: {},
      postData2: {},
      tipsFlag: false,
      tipsMsg: "",
      doctorName: "",
      payType: "",
      status: "",
      keyword: "",
      type: "",
      medType: "",
      prescrKind: "",
      startTime: start,
      endTime: end,
      flexWidth: 0,
      screenWidth: 0,
      payTypeOptions: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "现金处方",
        },
        {
          value: "2",
          label: "医保处方",
        }
      ],
      typeOptions: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "外配处方",
        },
        {
          value: "2",
          label: "院内处方",
        }
      ],
      medTypeOptions: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "11",
          label: "普通门诊",
        },
        {
          value: "140104",
          label: "门诊慢病",
        },
        {
          value: "140201",
          label: "门诊特病",
        },
        {
          value: "910101",
          label: "住院期间",
        }
      ],
      options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "0",
          label: "已过期",
        },
        {
          value: "1",
          label: "待审方",
        },
        {
          value: "2",
          label: "待使用",
        },
        {
          value: "3",
          label: "已使用",
        },
        {
          value: "4",
          label: "已作废",
        },
        {
          value: "5",
          label: "使用中",
        },
      ],
      prescrKindOptions: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "西药处方",
        },
        {
          value: "2",
          label: "中药处方",
        }
      ],
      auditStatus: 1,
      examineImg: '',
      examineLoading: false,
      isPdf: false,
      examinePdfUrl: null,
      scale: 100,
      prescriptionTimer: null,
    };
  },
  computed: {
    refreshFlag() {
      return this.$store.state.refreshPrescriptionFlag;
    }
  },
  created() {
    setInterval(() => {
      location.reload()
    }, 600000)
    if (localStorage.getItem("doctorType") == 2) {
      console.log("检测到药师身份，开启每分钟无感刷新列表");
      this.prescriptionTimer = setInterval(() => {
        this.search(true);
      }, 60000);
    }
  },
  beforeDestroy() {
    if (this.prescriptionTimer) {
      clearInterval(this.prescriptionTimer);
      this.prescriptionTimer = null;
    }
    window.onresize = null;
  },
  watch: {
    screenWidth: function (n, o) {
      this.flexWidth = n - 305;
      if (this.flexWidth < 1548) {
        this.flexWidth = 1548;
      }
    },
    refreshFlag: {
      handler(newVal, oldVal) {
        if (newVal > 0) {
          console.log("收到 Socket 刷新指令，立即刷新列表数据");
          this.search();
        }
      },
      immediate: true
    }
  },
  mounted() {
    let that = this;
    this.screenWidth = document.body.clientWidth;
    this.flexWidth = this.screenWidth - 305;
    if (this.flexWidth < 1548) {
      this.flexWidth = 1548;
    }
    window.onresize = () => {
      //屏幕尺寸变化
      return (() => {
        this.screenWidth = document.body.clientWidth;
        this.flexWidth = this.screenWidth - 305;
        if (this.flexWidth < 1548) {
          this.flexWidth = 1548;
        }
      })();
    };
    store.commit("SET_ORDERNUMBER", "");
    this.loadListData();
  },
  destroyed() {
    window.onresize = null;
  },
  methods: {
    open(row) {
      this.dialogVisible = true;
      this.detailsData = JSON.parse(JSON.stringify(row));
      this.details = row.prescriptionDrugList || [];
    },
    closeDialog() {
      this.dialogVisible = false;
      this.detailsData = {};
      this.details = [];
    },
    handleCurrentChange(val) {
      let upData = {
        cp: val.toString(),
        lz: "8",
      };
      upData.id = localStorage.getItem("doctorEmployee");
      prescriptionList(upData).then((query) => {
        if (query.code == 0) {
          this.PageCounts = query.data.total - 0;
          this.tableData = query.data.list;
        } else {
          this.errorTipsMsg(query.msg);
        }
      });
      this.medicineDialog = true;
    },
    loadListData() {
      this.loading = true;
      let data = {
        lz: "8",
        cp: "1",
        status: this.status,
        startTime: this.startTime,
        endTime: this.endTime,
        keyword: this.keyword,
        type: this.type,
        medType: this.medType,
        payType: this.payType,
        prescrKind: this.prescrKind,
      };
      prescriptionList(data).then((query) => {
        if (query.code == 0) {
          this.PageCounts = query.data.total;
          this.tableData = query.data.list;
          this.loading = false;
        } else {
          this.errorTipsMsg(query.msg);
          this.loading = false;
        }
      });
      this.doctorName = localStorage.getItem('doctorName');
    },
    search(isSilent = false) {
      if (!isSilent) {
        this.loading = true;
      }
      let data = {
        lz: "8",
        cp: "1",
        keyword: this.keyword,
        type: this.type,
        status: this.status,
        medType: this.medType,
        payType: this.payType,
        prescrKind: this.prescrKind,
        startTime: this.startTime,
        endTime: this.endTime,
      };
      prescriptionList(data, isSilent).then((query) => {
        if (query.code == 0) {
          this.PageCounts = query.data.total;
          this.tableData = query.data.list;
          this.loading = false;
        } else {
          this.loading = false;
          if (!isSilent) {
            this.errorTipsMsg(query.msg);
          }
        }
      });
    },
    chooseTime() {
      if (this.value1) {
        this.startTime = this.value1[0];
        this.startTime =
          this.startTime.getFullYear() +
          "-" +
          this.twoDigits(this.startTime.getMonth() + 1) +
          "-" +
          this.twoDigits(this.startTime.getDate()) +
          " " +
          this.twoDigits(this.startTime.getHours()) +
          ":" +
          this.twoDigits(this.startTime.getMinutes()) +
          ":" +
          this.twoDigits(this.startTime.getSeconds());
        this.endTime = this.value1[1];
        this.endTime =
          this.endTime.getFullYear() +
          "-" +
          this.twoDigits(this.endTime.getMonth() + 1) +
          "-" +
          this.twoDigits(this.endTime.getDate()) +
          " " +
          this.twoDigits(this.endTime.getHours()) +
          ":" +
          this.twoDigits(this.endTime.getMinutes()) +
          ":" +
          this.twoDigits(this.endTime.getSeconds());
      } else {
        this.startTime = "";
        this.endTime = "";
      }
    },
    twoDigits(val) {
      if (val < 10) return "0" + val;
      return val;
    },
    downLoad(URL, selfPlatType) {
      if (URL) {
        let postData = {
          path: URL,
        };
        let downLoadName = URL.split("/")[URL.split("/").length - 1];

        let fileExtension = "pdf";
        let mimeType = "image/pdf";

        if (selfPlatType === 2) {
          fileExtension = "jpg";
          mimeType = "image/jpeg";
        }

        if (!downLoadName.includes('.')) {
          downLoadName = downLoadName + '.' + fileExtension;
        } else {
          const nameWithoutExt = downLoadName.substring(0, downLoadName.lastIndexOf('.'));
          downLoadName = nameWithoutExt + '.' + fileExtension;
        }

        downLoadPdf(postData).then((data) => {
          if (data.code == 0) {
            let downLoadPath = "data:" + mimeType + ";base64," + data.data;
            this.downloadfun(downLoadName, downLoadPath);
            // download(downLoadPath,downLoadName,'text/plain');
          } else {
            this.tipsFlag = true;
            this.tipsMsg = data.msg;
            setTimeout(() => {
              this.tipsFlag = false;
            }, 2000);
          }
        });
      }
    },
    downloadfun(file_name, file_path) {
      var ajax = new XMLHttpRequest();
      ajax.open("GET", file_path, true);
      ajax.setRequestHeader("Cache-Control", "no-cache");
      ajax.setRequestHeader("Access-Control-Allow-Origin", "*");
      ajax.responseType = "blob";
      ajax.onload = (e) => {
        let res = e.target.response;
        let blob = new Blob([res]);
        let aLink = document.createElement("a");
        aLink.download = file_name;
        aLink.href = URL.createObjectURL(blob);
        aLink.click();
      };
      ajax.send();
    },
    ExamineEvent(row) {
      this.scale = 80;
      this.detailsData = JSON.parse(JSON.stringify(row));
      this.details = row.prescriptionDrugList || [];
      this.postData2 = { id: row.id, note: "", status: 1 };
      this.auditStatus = 1;
      this.ExamineNote = "";
      this.examineImg = "";
      if (this.examinePdfUrl) URL.revokeObjectURL(this.examinePdfUrl);
      this.examinePdfUrl = null;
      this.ExamineDialog = true;
      this.isPdf = row.selfPlatType !== 2;
      const auditList = row.prescriptionAuditList;
      const targetPath = (auditList && auditList.length > 0 && auditList[0].baseUrl)
        ? auditList[0].baseUrl
        : row.pdfPath;
      if (targetPath) {
        this.examineLoading = true;
        downLoadPdf({ path: targetPath }).then((res) => {
          if (res.code == 0) {
            if (res.data && res.data == null) {
              this.errorTipsMsg("暂未处方数据 !");
              return;
            }
            if (this.isPdf) {
              const byteCharacters = atob(res.data);
              const byteNumbers = new Array(byteCharacters.length);
              for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
              }
              const byteArray = new Uint8Array(byteNumbers);
              const blob = new Blob([byteArray], { type: 'application/pdf' });
              this.examinePdfUrl = URL.createObjectURL(blob);
            } else {
              this.examineImg = "data:image/jpeg;base64," + res.data;
            }
          }
          this.examineLoading = false;
        });
      }
    },
    CancelEvent(row) {
      this.CancelDialog = true;
      this.Cancel_note = "";
      this.postData = {
        id: row.id,
        note: "",
      };
    },
    CancelPost() {
      this.postData.note = this.Cancel_note;
      Cancel(this.postData).then((data) => {
        if (data.code == 0) {
          this.loadListData();
          this.CancelDialog = false;
        } else {
          this.errorTipsMsg(data.msg);
        }
      });
    },
    ExaminePostAgree() {
      this.postData2.note = this.ExamineNote;
      this.postData2.status = 1;
      Examine(this.postData2).then((data) => {
        if (data.code == 0) {
          this.loadListData();
          this.ExamineDialog = false;
          this.$message({
            message: "审核成功",
            type: "success",
          });
        } else {
          this.ExamineDialog = false;
          this.errorTipsMsg(data.msg);
        }
      });
    },
    ExaminePostApprove() {
      this.postData2.note = this.ExamineNote;
      this.postData2.status = 2;
      Examine(this.postData2).then((data) => {
        if (data.code == 0) {
          this.loadListData();
          this.ExamineDialog = false;
        } else {
          this.ExamineDialog = false;
          this.errorTipsMsg(data.msg);
        }
      });
    },
    tableRowClassName({ row, column, rowIndex, columnIndex }) {
      return "statusLine";
    },
    errorTipsMsg(str) {
      this.tipsFlag = true;
      this.tipsMsg = str;
      setTimeout(() => {
        this.tipsFlag = false;
      }, 2000);
    },
    async handleExamineSubmit() {
      if (this.auditStatus === 2 && !this.ExamineNote) {
        return this.$message.error("请填写驳回原因！");
      }
      this.postData2.note = this.ExamineNote;
      this.postData2.status = this.auditStatus;
      try {
        const data = await Examine(this.postData2);
        if (data && data.code == 0) {
          this.$message.success(this.auditStatus == 1 ? "审核通过成功" : "已成功驳回该处方");
          this.ExamineDialog = false;
          closeNotify();
          console.log("socket弹窗关闭了");
          if (this.$route.query.auditId) {
            this.$router.replace({ path: this.$route.path });
          }

          this.loadListData();
        } else {
          this.errorTipsMsg(data ? data.msg : '请求失败');
        }
      } catch (error) {
        console.error("捕获到错误:", error);
        this.errorTipsMsg("系统异常");
      }
    },
    getStatusLabel(status) {
      const obj = this.options.find(o => o.value == status);
      return obj ? obj.label : '';
    },
    getStatusClass(status) {
      if (status == '4') return 'statusStyle';
      if (status == '0') return 'statusStyle1';
      if (status == '1') return 'statusStyle2';
      if (status == '2') return 'statusStyle3';
      if (status == '3') return 'statusStyle4';
      if (status == '5') return 'statusStyle5';
      return '';
    },
    closeExamineDialog() {
      this.ExamineDialog = false;
      if (this.examinePdfUrl) {
        URL.revokeObjectURL(this.examinePdfUrl);
        this.examinePdfUrl = null;
      }
    },
    autoAudit(id) {
      if (this.ExamineDialog) {
        return;
      }
      const targetRow = this.tableData.find(item => item.id == id);
      if (targetRow) {
        this.ExamineEvent(targetRow);
      } else {
        this.loadListData();
      }
    },
  },
};
</script>
<style scoped>
.connet {
  padding: 1% 2%;
  min-height: 96%;
  background: rgb(245, 246, 250);
}

.connet>.tableBox {
  border-radius: 12px;
  background: #fff;
}

.connet .titleBox {
  line-height: 60px;
  font-size: 26px;
  text-align: center;
  color: rgba(0, 0, 0, 0.85);
}

.connet .searchBox {
  padding: 0% 2%;
  display: flex;
  justify-content: space-between;
  background: #fff;
}

.el-table {
  margin-bottom: 14px;
}

.el-table /deep/ .statusLine .cell {
  line-height: 26px;
}

.tipsMsgBox /deep/ .el-dialog__header {
  display: none;
}

.tipsMsgBox /deep/ .el-dialog__body {
  background: #fff;
  color: #0caf60;
  text-align: center;
}

/* Microsoft Edge 适配 */
.el-table .statusLine .cell {
  line-height: 26px;
}

.changeButton .el-button {
  display: block;
  margin: 0 auto;
}

.tipsMsgBox .el-dialog__header {
  display: none;
}

.tipsMsgBox .el-dialog__body {
  background: #fff;
  color: #0caf60;
  text-align: center;
}

.statusInput {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 15px;
}

.statusInput span {
  white-space: nowrap;
  color: #333;
  font-size: 14px;
}


.statusInput /deep/ input {
  width: 120px;
}

.CM_heand {
  margin-bottom: 24px;
  min-width: 1590px;
}

.CM_heand>div {
  margin-right: 20px;
}

.CM_heand :last-child {
  margin-right: 0px;
}

/* 两行布局样式 */
.filter-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 15px;
}

.search-row {
  display: flex;
  align-items: center;
  gap: 15px;
}

.flexBox {
  display: flex;
}

.orderMain {
  box-sizing: border-box;
  padding: 24px 20px;
}

/deep/ .audit-dialog .el-dialog__body {
  padding: 10px 10px !important;
}

.audit-dialog div::-webkit-scrollbar {
  width: 5px;
}

.audit-dialog div::-webkit-scrollbar-thumb {
  background: #ddd;
  border-radius: 10px;
}

.audit-dialog h3 {
  font-size: 15px;
  font-weight: bold;
  color: #333;
  margin: 20px 0 10px 0;
  border-left: 4px solid #0caf60;
  padding-left: 10px;
  line-height: 1;
}

.audit-dialog div::-webkit-scrollbar {
  width: 6px;
}

.audit-dialog div::-webkit-scrollbar-thumb {
  background: #e0e0e0;
  border-radius: 10px;
}


/deep/ .el-radio__input.is-checked .el-radio__inner {
  background-color: #0caf60 !important;
  border-color: #0caf60 !important;
}

/deep/ .el-radio__input.is-checked+.el-radio__label {
  color: #0caf60 !important;
}



.pdf-content>>>canvas {
  width: 100% !important;
  height: auto !important;
  image-rendering: -webkit-optimize-contrast !important;
  image-rendering: crisp-edges !important;
  text-rendering: optimizeLegibility;
}

.audit-dialog .el-dialog__body>div>div:first-child {
  background-color: #ebebeb !important;
}

.audit-h3 {
  font-size: 15px;
  font-weight: bold;
  color: #333;
  margin: 20px 0 10px 0;
  border-left: 4px solid #0caf60;
  padding-left: 10px;
  line-height: 1;
}

.no-border-table /deep/ {
  border: none !important;
}

.no-border-table /deep/ th {
  background-color: #fafafa !important;
  color: #999;
}

.no-border-table /deep/ td {
  border-bottom: 1px solid #f5f5f5 !important;
}

.zoom-bar {
  position: absolute;
  right: 40px;
  bottom: 20px;
  z-index: 100;
  background: rgba(255, 255, 255, 0.9);
  padding: 5px 15px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  gap: 15px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border: 1px solid #ddd;
}

.zoom-num {
  font-size: 14px;
  color: #606266;
  min-width: 40px;
  text-align: center;
  font-weight: bold;
}

.zoom-bar i {
  font-size: 20px;
  color: #0caf60;
  cursor: pointer;
  font-weight: bold;
}

.zoom-bar i:hover {
  opacity: 0.7;
}

.pdf-content {
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  transform-origin: top center;
  transition: width 0.2s;
  display: block;
  margin: 0 auto;
}
</style>